import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNetworkErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 140,
	height: 131,
	viewBox: "0 0 140 131",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M93.1272 14.7197C58.3482 -2.75204 16.6346 27.2856 6.97959 52.062C-16.2045 111.556 24.3106 139.012 42.1338 128.97C49.5744 124.777 55.6522 117.617 61.5262 110.651C70.3461 100.281 82.0318 94.3054 94.2859 93.8983C103.723 93.6341 113.116 96.7186 122.526 95.8129C131.937 94.9072 140.249 79.0991 139.994 67.6055C139.605 50.0625 130.422 33.4545 93.1272 14.7197Z",
			fill: "#FFF2F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.8493 93.5078H52.4297V107.635H87.8493V93.5078Z",
			fill: "#0DC277",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.0472 94.1343C20.5744 94.0992 18.1126 93.1576 16.2236 91.3084C12.3683 87.534 12.3621 81.408 16.21 77.626L48.2048 46.1304C52.0527 42.3484 58.2967 42.3426 62.1524 46.117C66.0076 49.8913 66.0139 56.0174 62.166 59.7993L30.1712 91.295C28.2087 93.224 25.6215 94.1709 23.0472 94.1343Z",
			fill: "#0DC277",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.0793 38.0821C53.6294 38.1027 49.8769 38.8477 45.6837 41.7774C43.4005 43.3727 34.7959 52.9958 33.0199 54.9928L32.5703 55.3425L46.1481 58.0673C46.1481 58.0673 51.2867 48.8385 52.2913 47.606C54.0568 45.4391 55.6651 43.5796 54.6725 43.1638C53.68 42.748 52.9288 43.4143 51.5175 44.714C46.4563 49.3754 46.9215 45.4819 46.932 45.3589C46.9491 45.1539 49.0708 42.8122 49.6138 42.4567C51.5521 41.1863 53.0429 40.3845 55.3412 39.3196C55.8729 39.0733 55.7604 38.0726 55.0797 38.0821H55.0793Z",
			fill: "white",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.2188 55.6191L46.6747 55.6114L50.2754 47.8565L46.4953 42.3262L36.3365 52.0505L33.2188 55.6191Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.3402 41.3477C49.3402 41.3477 50.9722 42.0243 52.0843 42.6447C52.6681 42.9704 53.5695 44.7639 53.7614 45.2618C54.4196 46.9708 53.5968 47.269 52.6611 46.5187C51.7818 45.8135 51.5421 45.0017 50.6367 44.4496C49.7921 43.9345 47.4844 43.6333 47.4844 43.6333",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.3402 41.3477C49.3402 41.3477 50.9722 42.0243 52.0843 42.6447C52.6681 42.9704 53.5695 44.7639 53.7614 45.2618C54.4196 46.9708 53.5968 47.269 52.6611 46.5187C51.7818 45.8135 51.5421 45.0017 50.6367 44.4496C49.7921 43.9345 47.4844 43.6333 47.4844 43.6333",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.539 42.5811C47.539 42.5811 49.3695 43.5097 50.4185 44.258C50.9619 44.6456 51.6676 46.3367 51.7388 46.8644C51.8482 47.6742 51.7236 48.0862 51.1242 48.0664C50.2687 48.0381 49.8537 46.3107 48.9488 45.7586C48.1042 45.2435 45.6797 44.0713 45.6797 44.0713",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.539 42.5811C47.539 42.5811 49.3695 43.5097 50.4185 44.258C50.9619 44.6456 51.6676 46.3367 51.7388 46.8644C51.8482 47.6742 51.7236 48.0862 51.1242 48.0664C50.2687 48.0381 49.8537 46.3107 48.9488 45.7586C48.1042 45.2435 45.6797 44.0713 45.6797 44.0713",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.7068 45.123C49.0232 46.377 48.9212 47.2109 48.9107 47.6519C48.8924 48.4022 48.3658 48.5828 47.9193 48.2143C47.3258 47.7244 46.5555 46.6778 46.1702 46.4816C45.3703 46.0738 43.9531 45.7057 43.9531 45.7057",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.5672 50.1719L13.9814 79.1842C12.463 81.2743 11.7916 83.9898 12.3883 86.6962C13.5131 91.7959 18.6389 95.0353 23.8374 93.9318L24.4018 93.8119",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.3705 93.9467L23.8061 94.0666C18.6076 95.1701 13.4819 91.9303 12.357 86.831C11.7603 84.1246 12.4318 81.409 13.9501 79.3189L34.5359 50.3066L48.5072 58.9764L34.5573 80.1368",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.3705 93.9467L23.8061 94.0666C18.6076 95.1701 13.4819 91.9303 12.357 86.831C11.7603 84.1246 12.4318 81.409 13.9501 79.3189L34.5359 50.3066L48.5072 58.9764L34.5573 80.1368",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.1787 43.3271L89.2224 43.3806C94.8619 43.4012 98.6172 47.0446 99.0761 50.5211C99.5988 54.4833 96.3854 58.3551 96.3939 58.6296C96.5185 62.5754 95.805 98.59 95.805 98.59L48.3906 97.8221L49.468 61.2737",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.1787 43.3271L89.2224 43.3806C94.8619 43.4012 98.6172 47.0446 99.0761 50.5211C99.5988 54.4833 96.3854 58.3551 96.3939 58.6296C96.5185 62.5754 95.805 98.59 95.805 98.59L48.3906 97.8221L49.468 61.2737",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7656 107.814C16.7227 106.794 22.3949 110.704 23.435 116.548C24.475 122.391 20.4889 127.956 14.5322 128.976",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4375 109.194C21.1776 110.354 22.9972 109.478 25.9152 108.979L28.3829 122.843C25.4649 123.343 22.5504 123.533 20.3322 125.459",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.875 109.562C18.875 109.562 26.3073 114.366 21.6078 124.571",
			stroke: "white",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1562 104.321L107.963 86.4356C116.42 84.8881 124.556 90.3597 126.133 98.6568C127.711 106.954 122.133 114.934 113.675 116.482C113.325 116.546 27.8076 128.169 27.8076 128.169L24.1562 104.322",
			fill: "#787878"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1562 104.321L107.963 86.4356C116.42 84.8881 124.556 90.3597 126.133 98.6568C127.711 106.954 122.133 114.934 113.675 116.482C113.325 116.546 27.8076 128.169 27.8076 128.169L24.1562 104.322",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.404 129.471C114.608 128.135 111.012 122.442 112.374 116.756C113.736 111.069 119.539 107.542 125.336 108.878",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.903 125.687C111.973 123.218 109.98 123.32 107.141 122.666L110.372 109.174C113.212 109.828 115.925 110.762 118.694 109.86",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.752 124.814C113.752 124.814 109.456 114.52 117.194 110.186",
			stroke: "white",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.334 128.961C109.334 128.961 25.0779 117.857 24.733 117.795C16.3981 116.305 10.873 108.469 12.3918 100.292C13.911 92.116 21.8987 86.696 30.2336 88.1859L112.831 105.463L109.335 128.961L109.334 128.961Z",
			fill: "#787878",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.4081 27.4171C77.0969 27.4171 82.5192 22.0978 82.5192 15.5362C82.5192 8.97453 77.0969 3.65527 70.4081 3.65527C63.7192 3.65527 58.2969 8.97453 58.2969 15.5362C58.2969 22.0978 63.7192 27.4171 70.4081 27.4171Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.4844 26.6045C81.3523 26.5468 82.8185 24.9947 82.7589 23.1379C82.7021 21.3609 81.2674 19.9523 79.507 19.8847C78.0283 13.9305 72.9092 9.51661 66.4955 9.7144C61.6734 9.86331 59.9954 12.4586 57.771 16.3395C56.594 18.3933 57.112 30.3204 58.7752 32.855C59.8872 34.5499 61.8505 35.6683 64.9958 36.1226L65.2465 43.0711C65.2465 43.0711 64.9195 49.545 72.3962 49.3182C80.8338 49.0623 79.8012 42.3441 79.8012 42.3441C79.8012 42.3441 79.1932 27.4197 79.4194 26.6037C79.4412 26.6037 79.4622 26.6056 79.484 26.6049L79.4844 26.6045Z",
			fill: "white",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.7344 15.3214L73.6153 15.0885C73.6153 15.0885 72.6929 19.662 77.0324 21.6258L77.731 24.8342L79.14 24.7907L79.8138 19.4421L78.3764 7.94951L67.9397 4.77539L57.3706 8.59747L54.7352 15.3214H54.7344Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.6336 18.4467C59.9616 18.4467 63.4702 15.0048 63.4702 10.759C63.4702 6.51318 59.9616 3.07129 55.6336 3.07129C51.3055 3.07129 47.7969 6.51318 47.7969 10.759C47.7969 15.0048 51.3055 18.4467 55.6336 18.4467Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.4085 13.2784C68.1463 13.2784 71.1764 10.3059 71.1764 6.63919C71.1764 2.97247 68.1463 0 64.4085 0C60.6707 0 57.6406 2.97247 57.6406 6.63919C57.6406 10.3059 60.6707 13.2784 64.4085 13.2784Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.0703 36.1219C65.0703 36.1219 68.2783 36.692 71.3404 34.7588L65.0703 36.1219Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.0703 36.1219C65.0703 36.1219 68.2783 36.692 71.3404 34.7588",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.7844 22.6138L68.7775 22.5565C68.7806 22.4775 68.7638 22.4041 68.7272 22.3358C68.7039 22.2648 68.6634 22.2033 68.6066 22.1514C68.5536 22.0956 68.491 22.0559 68.4186 22.033C68.3489 21.9971 68.2742 21.9807 68.1936 21.9838L68.0383 22.0044C67.9394 22.0315 67.8534 22.0807 67.7806 22.1518L67.6892 22.2678C67.6362 22.3572 67.6098 22.4534 67.6094 22.5569L67.6164 22.6142C67.6133 22.6932 67.63 22.7665 67.6666 22.8348C67.69 22.9059 67.7304 22.9673 67.7873 23.0193C67.8402 23.075 67.9029 23.1147 67.9752 23.1376C68.0449 23.1735 68.1197 23.1899 68.2002 23.1869L68.3555 23.1663C68.4544 23.1392 68.5404 23.0899 68.6132 23.0189L68.7047 22.9028C68.7576 22.8135 68.7841 22.7172 68.7844 22.6138Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.7532 23.1782L61.7462 23.1209C61.7493 23.0419 61.7326 22.9686 61.696 22.9003C61.6726 22.8292 61.6322 22.7678 61.5753 22.7158C61.5224 22.6601 61.4597 22.6204 61.3873 22.5975C61.3177 22.5616 61.2429 22.5452 61.1624 22.5482L61.007 22.5688C60.9082 22.5959 60.8222 22.6452 60.7494 22.7162L60.6579 22.8323C60.605 22.9216 60.5785 23.0179 60.5781 23.1213L60.5851 23.1786C60.582 23.2576 60.5988 23.331 60.6354 23.3993C60.6587 23.4703 60.6992 23.5318 60.756 23.5837C60.8089 23.6395 60.8716 23.6792 60.944 23.7021C61.0137 23.738 61.0884 23.7544 61.169 23.7513L61.3243 23.7307C61.4231 23.7036 61.5092 23.6544 61.582 23.5833L61.6734 23.4673C61.7264 23.3779 61.7528 23.2817 61.7532 23.1782Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.2672 24.5898L62.9383 26.2202C62.8776 26.5211 63.1481 26.7861 63.4548 26.7265L64.9128 26.4417",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.2672 24.5898L62.9383 26.2202C62.8776 26.5211 63.1481 26.7861 63.4548 26.7265L64.9128 26.4417",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.7891 18.7738C66.7891 18.7738 68.8804 18.0174 69.9811 19.3671L66.7891 18.7738Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.7891 18.7738C66.7891 18.7738 68.8804 18.0174 69.9811 19.3671",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.8125 20.5385C58.8125 20.5385 60.2211 18.844 61.8687 19.4568L58.8125 20.5385Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.8125 20.5385C58.8125 20.5385 60.2211 18.844 61.8687 19.4568",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.3355 34.7598L65.2048 41.7655L65.0156 36.3417C65.0156 36.3417 66.9049 36.3184 68.772 35.7621C70.6396 35.2057 71.3355 34.7598 71.3355 34.7598Z",
			fill: "#3C3C3C",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.5566 28.7184C68.5566 28.7184 66.4247 27.4922 65.625 29.5359L68.5566 28.7184Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.5566 28.7184C68.5566 28.7184 66.4247 27.4922 65.625 29.5359",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.3516 62.0733L106.813 91.2941C108.776 93.2231 111.363 94.17 113.937 94.1334C116.41 94.0982 118.872 93.1567 120.761 91.3075C124.616 87.5331 124.589 82.7656 120.774 77.6251L97.1995 46.6865",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.3516 62.0733L106.813 91.2941C108.776 93.2231 111.363 94.17 113.937 94.1334C116.41 94.0982 118.872 93.1567 120.761 91.3075C124.616 87.5331 124.589 82.7656 120.774 77.6251L97.1995 46.6865",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.1108 64.7703C83.0633 64.1732 82.9844 63.5886 82.9472 63.0471C82.8403 61.5021 83.0602 60.3106 83.8268 60.2255C85.9 59.9952 88.1332 64.371 90.4603 69.109L85.8778 72.8942L83.1108 64.7703Z",
			fill: "#FFFDFD",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.985 72.3092L90.3569 63.3416L81.7399 78.6591L110.98 93.3944C113.15 94.4181 115.609 94.3096 117.812 93.3069C119.927 92.3437 121.805 90.5566 122.963 88.1558",
			fill: "#0DC277"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.985 72.3092L90.3569 63.3416L81.7399 78.6591L110.98 93.3944C113.15 94.4181 115.609 94.3096 117.812 93.3069C119.927 92.3437 121.805 90.5566 122.963 88.1558",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.9002 71.9464L84.2373 52.0378C84.2111 51.2498 83.5499 50.626 82.7462 50.6309L74.4272 50.6798C73.5994 50.6847 72.9356 51.3537 72.9535 52.1658L73.3883 71.9097C73.4058 72.6928 74.0521 73.3219 74.8504 73.3329L83.3975 73.4486C84.2435 73.46 84.928 72.7755 84.9002 71.9464Z",
			fill: "#A0A0A0",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.1813 53.43C82.6784 53.43 83.0814 53.0346 83.0814 52.547C83.0814 52.0594 82.6784 51.6641 82.1813 51.6641C81.6842 51.6641 81.2812 52.0594 81.2812 52.547C81.2812 53.0346 81.6842 53.43 82.1813 53.43Z",
			fill: "white",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.1484 70.2538L84.8392 63.7905C84.8392 63.7905 74.2269 59.2357 73.3844 59.1646C72.3123 59.0747 71.8309 60.7424 72.5917 61.3194C73.0079 61.6353 73.5533 61.8225 73.9552 61.9761C73.1364 61.6566 72.584 62.1708 72.3327 62.7786C71.8733 63.8907 73.2698 64.4804 73.4297 64.5654C72.1283 64.5654 71.6175 66.0003 72.8577 66.8541C72.9397 66.9104 73.105 66.9872 73.2004 67.0323C73.0793 67.1687 72.5212 67.1674 72.4077 68.1502C72.3078 69.0138 73.2327 69.3982 73.6451 69.6705C74.1335 69.9929 83.4561 75.0078 83.4561 75.0078L86.1484 70.2538Z",
			fill: "#FFFDFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.0155 61.8778C73.6039 61.7116 72.9376 61.5193 72.4479 61.157C71.6733 60.5846 72.1634 58.9295 73.255 59.0191C74.1131 59.0892 84.9168 63.6087 84.9168 63.6087",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.1702 63.7375L73.8398 61.8082C73.0058 61.4908 72.443 62.001 72.1876 62.604C71.7199 63.7074 73.1416 64.2925 73.3044 64.3768C71.9795 64.3768 71.4594 65.8004 72.7221 66.6475C72.8056 66.7034 72.9734 66.7796 73.071 66.8244C72.9477 66.9597 72.3795 66.9584 72.264 67.9335C72.1622 68.7903 73.1038 69.1717 73.5237 69.4418C74.3424 69.9691 83.4549 75.0083 83.4549 75.0083",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.1641 64.2949L77.4484 66.0392",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.9531 66.7715L76.8184 68.5125",
			stroke: "#3C3C3C",
			strokeWidth: .5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.904 36.5263C110.904 36.5263 109.87 40.8505 106.15 43.8538C100.744 48.2191 90.5141 45.1709 87.3188 51.3105C86.6922 52.5145 86.2457 54.6108 86.2457 54.6108",
			stroke: "#646464",
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.416 33.4234C114.526 33.4234 116.237 31.7205 116.237 29.6199C116.237 27.5193 114.526 25.8164 112.416 25.8164C110.305 25.8164 108.594 27.5193 108.594 29.6199C108.594 31.7205 110.305 33.4234 112.416 33.4234Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.517 25.551C119.314 25.5511 119.114 25.5009 118.936 25.4049C118.757 25.3089 118.606 25.1702 118.494 25.0012C118.264 24.652 118.003 24.324 117.714 24.0213L117.572 23.8831C116.896 23.2083 116.092 22.6728 115.208 22.3075C114.323 21.9422 113.375 21.7542 112.417 21.7542C111.459 21.7542 110.511 21.9422 109.626 22.3075C108.741 22.6728 107.938 23.2083 107.261 23.8831C106.918 24.2234 106.611 24.598 106.345 25.0009C106.163 25.2587 105.887 25.4359 105.576 25.4952C105.265 25.5545 104.943 25.4912 104.678 25.3187C104.413 25.1462 104.226 24.878 104.155 24.5706C104.085 24.2632 104.138 23.9408 104.302 23.6712C104.66 23.1283 105.073 22.6236 105.535 22.1649C107.295 20.4095 109.666 19.3939 112.157 19.3277C114.648 19.2615 117.07 20.1497 118.922 21.8091H118.941L119.304 22.1649C119.766 22.6233 120.179 23.1279 120.537 23.6707C120.657 23.8539 120.726 24.066 120.735 24.2847C120.744 24.5034 120.694 24.7206 120.589 24.9132C120.485 25.1058 120.33 25.2667 120.141 25.379C119.952 25.4914 119.737 25.5509 119.517 25.5513L119.517 25.551Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.204 22.1859C99.9833 22.1855 99.7668 22.1257 99.5776 22.0127C99.3883 21.8998 99.2334 21.7379 99.1291 21.5443C99.0249 21.3507 98.9754 21.1326 98.9857 20.9132C98.9961 20.6939 99.0659 20.4814 99.1879 20.2983C99.7746 19.4186 100.448 18.5991 101.197 17.8519C104.172 14.8934 108.205 13.2314 112.41 13.2314C116.615 13.2314 120.648 14.8934 123.623 17.8519C124.372 18.597 125.045 19.4145 125.632 20.2923C125.727 20.425 125.794 20.5754 125.83 20.7345C125.865 20.8936 125.868 21.0582 125.838 21.2184C125.808 21.3787 125.747 21.5313 125.656 21.6673C125.566 21.8033 125.449 21.9199 125.313 22.0101C125.177 22.1003 125.023 22.1622 124.862 22.1923C124.702 22.2224 124.536 22.2199 124.376 22.1851C124.216 22.1503 124.065 22.0838 123.931 21.9896C123.798 21.8955 123.684 21.7755 123.598 21.6369C123.101 20.8936 122.531 20.2012 121.896 19.5701C119.38 17.0672 115.968 15.6613 112.41 15.6613C108.852 15.6613 105.44 17.0672 102.924 19.5701C102.289 20.203 101.719 20.8971 101.222 21.6421C101.111 21.8093 100.959 21.9465 100.782 22.0414C100.604 22.1362 100.406 22.1859 100.204 22.1859Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.622 18.882C129.421 18.8821 129.223 18.8327 129.045 18.7381C128.867 18.6434 128.716 18.5066 128.605 18.3397C127.886 17.2642 127.062 16.2622 126.145 15.3484C122.504 11.7255 117.566 9.69029 112.417 9.69029C107.268 9.69029 102.33 11.7255 98.6883 15.3484C97.7701 16.2646 96.9436 17.2675 96.2207 18.343C96.037 18.6029 95.7584 18.781 95.4445 18.839C95.1306 18.897 94.8063 18.8304 94.5412 18.6535C94.276 18.4765 94.091 18.2032 94.0258 17.8922C93.9605 17.5811 94.0203 17.257 94.1922 16.9893C95.0038 15.7826 95.9313 14.6573 96.9619 13.6295C101.061 9.55095 106.62 7.25977 112.416 7.25977C118.213 7.25977 123.772 9.55095 127.871 13.6295C128.903 14.6571 129.829 15.784 130.638 16.9937C130.76 17.1767 130.83 17.3892 130.84 17.6086C130.851 17.828 130.801 18.0461 130.697 18.2398C130.593 18.4335 130.438 18.5954 130.249 18.7085C130.06 18.8215 129.843 18.8817 129.622 18.882Z",
			fill: "#A0A0A0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.858 39.9335C130.962 39.9335 135.099 35.816 135.099 30.7368C135.099 25.6575 130.962 21.54 125.858 21.54C120.754 21.54 116.617 25.6575 116.617 30.7368C116.617 35.816 120.754 39.9335 125.858 39.9335Z",
			fill: "#FD5D76"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.506 35.4837C129.374 35.4839 129.244 35.4575 129.122 35.406C129.001 35.3546 128.891 35.2792 128.799 35.1845L121.509 27.6421C121.42 27.5498 121.35 27.4408 121.302 27.3214C121.255 27.202 121.232 27.0746 121.235 26.9463C121.237 26.818 121.265 26.6915 121.316 26.5739C121.368 26.4564 121.442 26.3501 121.535 26.2611C121.628 26.1721 121.737 26.1023 121.857 26.0555C121.978 26.0087 122.106 25.9859 122.234 25.9885C122.363 25.991 122.49 26.0188 122.609 26.0702C122.727 26.1217 122.833 26.1958 122.923 26.2884L130.213 33.8307C130.346 33.9686 130.436 34.1426 130.471 34.3308C130.506 34.5191 130.484 34.7134 130.409 34.8895C130.333 35.0656 130.208 35.2158 130.047 35.3214C129.887 35.4269 129.699 35.4832 129.506 35.4831V35.4837Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.215 35.4843C122.023 35.4844 121.835 35.4282 121.674 35.3227C121.514 35.2171 121.388 35.0669 121.313 34.8907C121.237 34.7146 121.216 34.5203 121.251 34.332C121.285 34.1437 121.375 33.9698 121.509 33.8319L128.799 26.2895C128.888 26.1972 128.995 26.1232 129.113 26.0719C129.231 26.0206 129.358 25.9929 129.487 25.9904C129.616 25.988 129.744 26.0108 129.864 26.0575C129.983 26.1043 130.093 26.1741 130.186 26.263C130.279 26.3519 130.353 26.4581 130.405 26.5756C130.456 26.6931 130.484 26.8195 130.486 26.9477C130.489 27.0758 130.466 27.2032 130.419 27.3226C130.372 27.4419 130.302 27.5509 130.212 27.6433L122.922 35.1857C122.831 35.2804 122.721 35.3556 122.599 35.407C122.478 35.4583 122.347 35.4846 122.215 35.4843Z",
			fill: "white"
		})
	]
});
export default SvgNetworkErrorIcon;
